export default "__VITE_ASSET__CLlRbx$y__"